export const BASE_URL = "https://api.pmall.com.ng/api/v1";
